module.exports = __webpack_public_path__ + "img/pasta_1.51621497.svg";